import { useState, useRef, useEffect } from "react";
import { X } from "lucide-react";

const AddAdicionaisProduto = ({ adicionaisProduto, toggleSelecionado }) => {
    const [termo, setTermo] = useState("");
    const [focado, setFocado] = useState(false);

    const containerRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setFocado(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const adicionaisSelecionados = adicionaisProduto.filter((a) => a.selecionado);
    const adicionaisFiltrados = adicionaisProduto.filter(
        (a) => !a.selecionado && a.nome.toLowerCase().includes(termo.toLowerCase())
    );

    const formatValue = (value) =>
        value === 0.0 ? "Gratuito" : `+ R$ ${value.toFixed(2).replace('.', ',')}`;

    return (
        <div className="relative mb-2" ref={containerRef}>
            <div
                className="w-full border rounded-md p-2 min-h-[42px] flex flex-wrap items-center gap-2 cursor-text"
                onClick={() => inputRef.current?.focus()}
            >
                {adicionaisSelecionados.map((a) => (
                    <div
                        key={a.id}
                        className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md flex items-center gap-2 text-sm whitespace-nowrap"
                    >
                        <span>{a.nome}</span>
                        <button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleSelecionado(a.id);
                            }}
                        >
                            <X className="w-4 h-4 text-blue-500 hover:text-red-500" />
                        </button>
                    </div>
                ))}
                <input
                    ref={inputRef}
                    type="text"
                    placeholder={adicionaisSelecionados.length === 0 ? "Buscar adicional..." : ""}
                    className="flex-grow bg-transparent outline-none border-none p-0 m-0"
                    value={termo}
                    onChange={(e) => setTermo(e.target.value)}
                    onFocus={() => setFocado(true)}
                />
            </div>

            {focado && (
                <div className="absolute z-20 bg-white border rounded-md mt-1 w-full shadow-lg max-h-52 overflow-auto">
                    <ul className="divide-y divide-slate-100">
                        {adicionaisFiltrados.length === 0 ? (
                            <li className="p-3 text-sm text-center text-gray-500">Nenhum adicional encontrado</li>
                        ) : (
                            adicionaisFiltrados.map((a) => (
                                <li key={a.id}>
                                    <label
                                        htmlFor={`adicional-${a.id}`}
                                        className="p-3 hover:bg-blue-50 cursor-pointer text-sm flex items-center justify-between"
                                    >
                                        <div className="flex items-center gap-3">
                                            <input
                                                type="checkbox"
                                                id={`adicional-${a.id}`}
                                                checked={a.selecionado || false}
                                                onChange={() => toggleSelecionado(a.id)}
                                                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                            />
                                            <span>{a.nome}</span>
                                        </div>
                                        <span className="text-xs text-gray-600">{formatValue(a.valorExtra)}</span>
                                    </label>
                                </li>
                            ))
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default AddAdicionaisProduto;